import { render } from "./ForegroundContent.vue?vue&type=template&id=6680186b&scoped=true"
import script from "./ForegroundContent.vue?vue&type=script&lang=js"
export * from "./ForegroundContent.vue?vue&type=script&lang=js"

import "./ForegroundContent.vue?vue&type=style&index=0&id=6680186b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6680186b"]])

export default __exports__